export default "__VITE_ASSET__DY7WnD4a__"